import React from 'react'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'

import { handleDecimalKeyDown } from 'helpers/decimalKey'
import { formatDate, formatMoney, formatMoneyInput } from 'helpers/helpers'

// Возврат поставщику, который на деле — точка другого логина. Вернуть можно только
// то, что пришло перемещением: выбираем перемещение, по строкам вводим количество.
// Цена — из прихода, её не меняем: на эту сумму начислен долг поставщику.
function IntegrationItems({ transfers, transferId, items, onSelectTransfer, onChangeQuantity }) {
	const { t } = useTranslation()

	const totalAmount = items.reduce((sum, item) => sum + Number(item.quantity || 0) * Number(item.price), 0)

	return (
		<>
			<div className="row mb-3">
				<div className="col-md-4">
					<div className="form-group mb-0">
						<label>{t('return_basis_transfer')}<span className="required-mark">*</span></label>
						<Select
							options={transfers}
							value={transfers.find(option => option.id === transferId) ?? null}
							onChange={(option) => onSelectTransfer(option.id)}
							placeholder={t('select_transfer')}
							noOptionsMessage={() => t('no_transfers_to_return')}
							getOptionLabel={(option) =>
								`№${option.id} · ${formatDate(option.created_at, 'dd.MM.yy')} · ${formatMoney(option.available_amount)}`}
							getOptionValue={(option) => option.id}
						/>
					</div>
				</div>
				<div className="col-md-8 vertical-center">
					<small className="text-muted">{t('integration_return_hint')}</small>
				</div>
			</div>

			{!!transferId &&
				<table className="table table-bordered">
					<thead>
						<tr>
							<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
							<th style={{ 'width': '35%' }}>{t('name2')}</th>
							<th style={{ 'width': '8%' }}>{t('unit')}</th>
							<th style={{ 'width': '10%' }} className="text-end">{t('received_qty')}</th>
							<th style={{ 'width': '10%' }} className="text-end">{t('already_returned')}</th>
							<th style={{ 'width': '10%' }} className="text-end">{t('available_to_return')}</th>
							<th style={{ 'width': '10%' }} className="text-end">{t('quantity')}</th>
							<th style={{ 'width': '7%' }} className="text-end">{t('price')}</th>
							<th style={{ 'width': '10%' }} className="text-end">{t('amount')}</th>
						</tr>
					</thead>
					<tbody>
						{items.map((item, index) => {
							const isOver = Number(item.quantity) > Number(item.available) + 0.0001
							return (
								<tr key={item.wms_transfer_pos_product_id}>
									<td className="text-center">{index + 1}</td>
									<td>{item.product_name}</td>
									<td>{item.unit_name}</td>
									<td className="text-end">{formatMoney(item.received, 3)}</td>
									<td className="text-end">{formatMoney(item.returned, 3)}</td>
									<td className="text-end">{formatMoney(item.available, 3)}</td>
									<td className="td-input" style={isOver ? { 'borderBottom': '2px solid red' } : {}}>
										<input
											type="text"
											className="form-control text-end"
											placeholder="0"
											disabled={Number(item.available) <= 0}
											value={formatMoneyInput(item.quantity) ?? ''}
											onChange={(e) => onChangeQuantity(index, e.target.value)}
											onKeyDown={(e) => handleDecimalKeyDown(e, (event) => onChangeQuantity(index, event.target.value))} />
									</td>
									<td className="text-end">{formatMoney(item.price)}</td>
									<td className="text-end">{formatMoney(Number(item.quantity || 0) * Number(item.price), 2)}</td>
								</tr>
							)
						})}
						<tr>
							<td></td>
							<td><b>{t('total')}</b></td>
							<td colSpan={6}></td>
							<td className="text-end"><b>{formatMoney(totalAmount, 2)}</b></td>
						</tr>
					</tbody>
				</table>
			}
		</>
	)
}

export default IntegrationItems
